import { LogoMark } from "@/components/Logo";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
  { id: "minusta", label: "Minusta" },
  { id: "palautteet", label: "Palaute" },
  { id: "palvelut", label: "Palvelut" },
  { id: "ilta-ja-yo", label: "Ilta & yö" },
  { id: "yhteydenotto", label: "Yhteys" },
];

export const Footer = () => (
  <footer className="bg-petrol-night text-cream">
    <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8 sm:py-20">
      <div className="flex flex-col gap-12 lg:flex-row lg:items-start lg:justify-between">
        <div className="max-w-sm">
          <div className="flex items-center gap-3">
            <LogoMark className="h-11 w-11" />
            <div className="leading-none">
              <p className="font-serif text-2xl font-semibold">Kaisan koto</p>
              <p className="mt-1 text-[0.6rem] font-semibold uppercase tracking-[0.3em] text-cream/50">Lastenhoitoa iltoihin & viikonloppuihin</p>
            </div>
          </div>
          <p className="mt-6 text-sm leading-relaxed text-cream/60">
            Luotettavaa ja henkilökohtaista lastenhoitoa – myös iltaisin,
            viikonloppuisin ja sovittaessa yöksi.
          </p>
        </div>

        <nav className="grid grid-cols-2 gap-x-12 gap-y-3 sm:grid-cols-3">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollToId(l.id)}
              className="text-left text-sm text-cream/70 transition-colors hover:text-beige"
              data-testid={`footer-link-${l.id}`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="space-y-2 text-sm text-cream/70">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-cream/40">Yhteystiedot</p>
          <p data-testid="footer-contact-email">kaisa.aleksandra.kivinen@gmail.com</p>
          <p data-testid="footer-contact-location">Helsinki · Espoo · Vantaa</p>
        </div>
      </div>

      <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-cream/10 pt-8 sm:flex-row">
        <p className="text-xs text-cream/45">
          © {new Date().getFullYear()} Kaisan koto · Toiminimi
        </p>
        <p className="text-xs text-cream/45">Pääkaupunkiseutu · Myös iltaisin ja viikonloppuisin</p>
      </div>
    </div>
  </footer>
);
